module.exports = __webpack_public_path__ + "img/tablet-pastelaria.713c5542.webp";